<template>
    <div>
        Instruction système <b-button style="padding: 1px;" variant="link" v-b-tooltip.hover title="Message système pour préciser le rôle de ChatGPT, par exemple : Je suis un assistant expert en seo."><i class="fas fa-info"></i></b-button>
        <b-select style="margin:5px; width: 100px; display: inline;" v-model="type_system" :options="[
            {value: 'column', text: 'Colonne'},
            {value: 'prompt', text: 'Prompt'}
        ]" />
        <div v-if="type_system != 'prompt'">
            <b-input v-model="column_system" :list="'column_system' + id" />
            <datalist :id="'column_system' + id">
                <option v-for="item in columns_data" :key="item">
                    {{ item }}
                </option>
            </datalist>
        </div>
        <div v-if="type_system == 'prompt'">
            <textarea_plus :height="100" ref="t_system" :columns="columns_data"></textarea_plus>
        </div>
        Requête
        <b-select style="margin:5px; width: 100px; display: inline;" v-model="type_user" :options="[
            {value: 'column', text: 'Colonne'},
            {value: 'prompt', text: 'Prompt'}
        ]" />
        <div v-if="type_user != 'prompt'">
            <b-input v-model="column_user" :list="'column_user' + id" />
            <datalist :id="'column_user' + id">
                <option v-for="item in columns_data" :key="item">
                    {{ item }}
                </option>
            </datalist>
        </div>
        <div v-if="type_user == 'prompt'">
            <textarea_plus ref="t_user" :columns="columns_data"></textarea_plus>
        </div>
        Réponse attendu
        <b-select style="margin:5px; width: 100px; display: inline;" v-model="type_assistant" :options="[
            {value: 'column', text: 'Colonne'},
            {value: 'prompt', text: 'Prompt'}
        ]" />
        <div v-if="type_assistant != 'prompt'">
            <b-input v-model="column_assistant" :list="'column_assistant' + id" />
            <datalist :id="'column_assistant' + id">
                <option v-for="item in columns_data" :key="item">
                    {{ item }}
                </option>
            </datalist>
        </div>
        <div v-if="type_assistant == 'prompt'">
            <textarea_plus ref="t_assistant" :columns="columns_data"></textarea_plus>
        </div>
        Nom du modèle - 18 caractères maximum
        <b-input v-model="suffix" />
        <div v-show="suffix.length > 18" :style="'color:' + (suffix.length > 18 ? 'red': 'black')">{{ suffix.length }} caractère{{ suffix.length > 1 ? 's' : ''}}</div>
        Modèle de départ
        <b-input v-model="model" :list="'model' + id" />
        <datalist :id="'model' + id">
            <option>gpt-3.5-turbo</option>
            <option>gpt-4o-2024-08-06</option>
        </datalist>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    import json_schema_editor from "../json_schema_editor.vue";
    import workers_service from "../../services/workers.js"
    import edit_tabulator from "../edit_tabulator.vue";
    import textarea_plus from '../textarea_plus.vue';
	import library from "../../services/library.js";

    var clone = require("clone");
    
    export default {
        name: "chatgpt_train",
		components: {
            json_schema_editor,
            edit_tabulator,
            textarea_plus
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            },
			user_params_config: {
				default: ""
			},
			user_params_test: {
				default: false
			},
			project_uid: {
				default: ""
			},
			step_position: {
				default: 0
			}
        },
        watch: 
        {
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),

                columns_data: [],

                column_system: "",
                type_system: "prompt",
                column_user: "",
                type_user: "column",
                column_assistant: "",
                type_assistant: "column",
                suffix: "",
                model: ""
			};
        },
        methods: {
            save()
            {
                var data = {
                    type_system: this.type_system,
                    type_user: this.type_user,
                    type_assistant: this.type_assistant,
                    suffix: this.suffix,
                    model: this.model
                }

                if (this.type_system == 'prompt')
                    data.prompt_system = this.$refs.t_system.get_data();
                else
                    data.column_system = this.column_system;

                if (this.type_user == 'prompt')
                    data.prompt_user = this.$refs.t_user.get_data();
                else
                    data.column_user = this.column_user;

                if (this.type_assistant == 'prompt')
                    data.prompt_assistant = this.$refs.t_assistant.get_data();
                else
                    data.column_assistant = this.column_assistant;

                return data;
            },
            async load(data)
            {
                var self = this;

                console.log("load " + this.id)
                
                if (!data)
                {
                    return;
                }

                console.log(data)

                this.suffix = data.suffix;
                this.model = data.model;
                this.type_system = data.type_system || "column";
                this.column_system = data.column_system || "";
                this.type_user = data.type_user || "column";
                this.column_user = data.column_user || "";
                this.type_assistant = data.type_assistant || "column";
                this.column_assistant = data.column_assistant || "";

                if (data.prompt_system)
                    this.type_system = "prompt";
                if (data.prompt_user)
                    this.type_user = "prompt";
                if (data.prompt_assistant)
                    this.type_assistant = "prompt";

                this.$nextTick(() => {
                    if (data.prompt_system)
                        self.$refs.t_system.load(data.prompt_system);
                    if (data.prompt_user)
                        self.$refs.t_user.load(data.prompt_user);
                    if (data.prompt_assistant)
                        self.$refs.t_assistant.load(data.prompt_assistant);
                })

            },
        },
        async mounted()
        {
        }
    }
</script>

<style scoped>
</style>